import React, { useState, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import esLocale from '@fullcalendar/core/locales/es';
import './agenda.css';
import { agenda } from '../../json/agenda';

const Agenda = () => {
    const [events, setEvents] = useState([]);
    const [modalStatus, setModalStatus] = useState(false);
    const [eventData, setEventData] = useState([]);

    useEffect(() => {
        setEvents(agenda);
        window.scrollTo(0, 0);
    }, []);


    const handleEventClick = (eventClickInfo) => {
        // Obtener información del evento
        setModalStatus(true);
        const eventTitle = eventClickInfo.event.title;
        const eventPlace = eventClickInfo.event.extendedProps.place;
        const eventDescription = eventClickInfo.event.extendedProps.description;
        
        setEventData([eventTitle, eventPlace, eventDescription]);
    };

    const calendarOptions = {
        plugins: [dayGridPlugin],
        initialView: 'dayGridMonth',
        weekends: true,
        events: events,
        eventClick: handleEventClick // Agregar manejador de eventos
    };

    return (
        <>
            <div id='calendar'>
                <div className='container'>
                    <div className='row'>
                        <div>
                            <h3 className='title'>Agenda del Titular</h3>
                            <hr className='hr-gob'/>
                        </div>
                        {
                            modalStatus ? 
                            <div id='modal-agenda'>
                                <div className='close-icon' style={{ float: 'right' }}>
                                    <i className="bi bi-x-circle" onClick={() => {setModalStatus(false)}}/>
                                </div>
                                <p className='agenda-title'>{ eventData[0] }</p>
                                <p className='agenda-location'><i className="bi bi-geo-alt-fill"></i>{ eventData[1] }</p>
                                <iframe className='twitter-embed' title='Twitter Embed' srcDoc={eventData[2]}></iframe>
                               {/* <iframe id="url" src={eventData[2]} className='twitter-embed' frameborder="0" scrolling="auto" allowTransparency="true" allow="encrypted-media"></iframe> */}
                            </div> :null
                        }
                        <div className='container'>
                            <div className="agenda">
                                <FullCalendar
                                   plugins={[dayGridPlugin]}
                                   locales={[esLocale]}
                                   locale='es'
                                   {...calendarOptions}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
        
    )
}

export default Agenda;
